<template>
  <nav class="the-nav">
    <ul class="the-nav__list"><!--
    --><li ref="item" class="the-nav__list-item" v-for="{ year } in years" :key="year">
        <router-link class="the-nav__btn"
          active-class="the-nav__btn--active"
          :to="year"
          :title="year"
          @click.prevent="onNavItemClick($event, year)"><!--
        --><span class="the-nav__btn-label">{{ year }}</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { ELECTION_NAV_CONFIG } from '@/constant'

export default {
  name: 'TheNav',
  data () {
    return {
      data: ELECTION_NAV_CONFIG
    }
  },
  computed: {
    years () {
      return this.data
        .filter(({ disable }) => !disable)
    },
    currentYear () {
      return this.$route.params.year
    },
    currentYearIndex () {
      return this.years
        .map(({ year }) => year)
        .indexOf(this.currentYear)
    }
  }
}
</script>

<style lang="scss">
.the-nav {
  @include use-layer(&);
  display: block;
  position: fixed;
  top: 220px;
  left: 25px;
  background: #1a1a1a;
  border: 1px solid #1a1a1a;
  opacity: 0;
  user-select: none;
  transform: translateX(-500px);
  @include rwd($RWD_TABLET) {
    opacity: 1;
    transform: translateX(0);
    transition:
      opacity 0.4s,
      transform 0.4s;
  }
  @include rwd($RWD_DESKTOP) {
    top: 200px;
  }
  @include rwd($RWD_DESKTOP_1440) {
    top: 270px;
    left: auto;
    right: 50%;
    margin-right: (1140px / 2 + 60px);
  }

  &__list {
    position: relative;
    white-space: nowrap;

    &-item {
      // display: block;
      position: relative;
      width: 70px;
      height: 45px;
      color: white;
      vertical-align: top;
    }
  }

  &__btn {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    color: inherit;
    text-align: center;
    background: #1a1a1a;
    transition: background-color 0.5s;
    cursor: pointer;
    @include use-vertical-align();

    &:active {
      padding-top: 2px;
    }

    &-label {
      vertical-align: middle;
      font-size: 1.125em;
    }

    &--active {
      color: #1a1a1a;
      background: white;
      transition-duration: 0.3s;
    }
  }
}

.desktop {
  $comp: ".the-nav";

  #{$comp} {
    &__btn {
      &:hover {
        color: #1a1a1a;
        background: #b4b4b4;
      }
    }
  }
}

.narrow-desktop {
  $comp: ".the-nav";

  #{$comp} {
    @include rwd($RWD_DESKTOP) {
      top: 100px;
    }
  }
}
</style>
